/**
 * Add multiple classes to a DOM element.
 *
 * We use the classList.add method with a single argument in order to be
 * compatible with IE11.
 * @param el - The element on which to add the given classes.
 * @param classNames - The classes to add to the element.
 */
export function addClassNames(el, classNames) {
    classNames.forEach((className) => {
        el.classList.add(className);
    });
}
/**
 * Create a new DOM element (extends built-in document.createElement() with
 * more initialization options).
 * @param args - The element creation arguments.
 * @returns The new DOM element.
 */
export function createElement({ tagName, classNames, innerHTML, }) {
    const el = document.createElement(tagName);
    if (classNames) {
        addClassNames(el, classNames);
    }
    if (innerHTML) {
        el.innerHTML = innerHTML;
    }
    return el;
}
//# sourceMappingURL=dom.js.map